export default __webpack_public_path__ + "images/arrowRight.v-2eee2a0e419f14e6ff06da78dbd6557f.svg";